<template>
  <div class="order-form form">
      <img src="/images/default/spinner-lg.gif" alt="Loading ..." v-show="state.status.isLoading" />

      <div class="order-form-content" v-show="!state.status.isLoading">
          <!-- Groups -->
          <div v-for="attributeGroup in state.attributesGroups"
               :key="attributeGroup.Id"
               :name="'header' + attributeGroup.Id"
               :id="'header' + attributeGroup.Id">

              <a class="form-header" :href="'#header' + attributeGroup.Id" @click="toggleGroup(attributeGroup.Id, $event)">
                  <h4 class="form-header-title">
                      {{ getCustomerLabel(attributeGroup.Label) }}
                  </h4>

                  <transition name="fade">
                      <span class="glyphicon glyphicon-plus-sign pull-right form-header-icon"
                            v-show="!isActiveGroup(attributeGroup.Id)">
                      </span>
                  </transition>
                  
                  <transition name="fade">
                      <span class="glyphicon glyphicon-minus-sign pull-right form-header-icon"
                            v-show="isActiveGroup(attributeGroup.Id)">
                      </span>
                  </transition>                    
              </a>                

              <transition name="slide">
                  <div class="order-form-attributes" v-show="isActiveGroup(attributeGroup.Id)">

                      <div class="form-group" v-for="attribute in state.attributes" :key="attribute.Id"
                           v-if="attribute.ProductAttributeGroupId == attributeGroup.Id">

                          <label :class="{'required': attribute.IsRequired}" :for="attribute.Name + attribute.Id">
                              {{ getCustomerLabel(attribute.Label) }}
                          </label>

                          <!-- DropDown -->
                          <select class="form-control"
                                  :id="attribute.Name + attribute.Id"
                                  :name="attribute.Name + attribute.Id"
                                  :required="attribute.IsRequired"
                                  v-validate
                                  v-bind:class="{error : errors.first(attribute.Name + attribute.Id)}"
                                  v-if="attribute.Type == 3"
                                  v-model="attribute.Value">
                              <option v-for="option in attribute.Options">
                                  {{ getCustomerLabel(option.Label) }}
                              </option>
                          </select>

                          <!-- Number -->
                          <input type="number" class="form-control"
                                 :id="attribute.Name + attribute.Id"
                                 :name="attribute.Name + attribute.Id"
                                 v-validate
                                 :required="attribute.IsRequired"
                                 v-bind:class="{error : errors.first(attribute.Name + attribute.Id)}"
                                 v-if="attribute.Type == 2"
                                 v-model="attribute.Value" />

                          <!-- String -->
                          <input type="text" class="form-control"
                                 :id="attribute.Name + attribute.Id"
                                 :name="attribute.Name + attribute.Id"
                                 :required="attribute.IsRequired"
                                 v-validate
                                 v-bind:class="{error : errors.first(attribute.Name + attribute.Id)}"
                                 v-if="attribute.Type == 1"
                                 v-model="attribute.Value" />

                          <!-- File -->
                          <input type="file" class="form-control"
                                 :id="attribute.Name + attribute.Id"
                                 :name="attribute.Name + attribute.Id"
                                 :accept="attribute.AllowedExtensions"
                                 v-bind:class="{error : errors.first(attribute.Name + attribute.Id)}"
                                 v-if="attribute.Type == 4"
                                 @change="onFileChanged(attribute, $event)" />

                          <p class="help-block">{{ getCustomerLabel(attribute.LabelDescription) }}</p>

                      </div>
                  </div>
              </transition>
          </div>

          <!-- Empty Group -->
          <div class="form-group" v-for="attribute in state.attributes" v-if="attribute.ProductAttributeGroupId == 0">
              <label :class="{'required': attribute.IsRequired}" :for="attribute.Name + attribute.Id">
                  {{ getCustomerLabel(attribute.Label) }}
              </label>

              <!-- DropDown -->
              <select class="form-control"
                      :id="attribute.Name + attribute.Id"
                      :name="attribute.Name + attribute.Id"
                      :required="attribute.IsRequired"
                      v-validate
                      v-bind:class="{error : errors.first(attribute.Name + attribute.Id)}"
                      v-if="attribute.Type == 3"
                      v-model="attribute.Value">
                  <option v-for="option in attribute.Options">
                      {{ getCustomerLabel(option.Label) }}
                  </option>
              </select>

              <!-- Number -->
              <input type="number" class="form-control"
                     :id="attribute.Name + attribute.Id"
                     :name="attribute.Name + attribute.Id"
                     v-validate
                     :required="attribute.IsRequired"
                     v-bind:class="{error : errors.first(attribute.Name + attribute.Id)}"
                     v-if="attribute.Type == 2"
                     v-model="attribute.Value" />

              <!-- String -->
              <input type="text" class="form-control"
                     :id="attribute.Name + attribute.Id"
                     :name="attribute.Name + attribute.Id"
                     :required="attribute.IsRequired"
                     v-validate
                     v-bind:class="{error : errors.first(attribute.Name + attribute.Id)}"
                     v-if="attribute.Type == 1"
                     v-model="attribute.Value" />

              <!-- File -->
              <input type="file" class="form-control"
                     :id="attribute.Name + attribute.Id"
                     :name="attribute.Name + attribute.Id"
                     :accept="attribute.AllowedExtensions"
                     v-bind:class="{error : errors.first(attribute.Name + attribute.Id)}"
                     v-if="attribute.Type == 4"
                     @change="onFileChanged(attribute, $event)" />

              <p class="help-block">{{ getCustomerLabel(attribute.LabelDescription) }}</p>
          </div>

          <div class="form-group">
              <label for="qty" class="required">
                  {{ getLabel('qty') }}
              </label>

              <input type="number" class="form-control" name="qty" id="qty" required="required"
                     v-bind:class="{error : errors.first('qty')}"
                     v-model="state.qty"
                     v-validate />
          </div>

          <div class="form-group form-group-lg">
              <button class="btn btn-primary btn-lg form-control" @click="addToCart($event)">
                  <span v-show="!state.status.isAdding">
                      {{ getLabel('web_add_cart') }}
                      <span class="glyphicon glyphicon-shopping-cart">
                      </span>
                  </span>
                  <img src="/images/default/spinner-inverse-sm.gif" alt="Loading..." v-show="state.status.isAdding" />
              </button>
          </div>
      </div>
  </div>
</template>
<script>

  import { store } from './store.js';    
  import { shared } from './shared.js';    
  import VeeValidate from 'vee-validate';    
  import Datepicker from 'vuejs-datepicker';
  import Vue from 'vue';

  Vue.use(VeeValidate, { validity: true });

  export default {        
      mixins: [shared],
      components: {
          'datepicker': Datepicker
      },
      data: function () {
          return {
              state: store.state
          }            
      },
      methods: {
          addToCart: function (e) {
              e.preventDefault();

              var self = this;

              if (self.state.status.isAdding) {
                  return;
              }
                              
              this.$validator.validateAll().then((isValid) => {

                  // Validate Input file manually 
                  var inputsFile = _.filter(self.state.attributes, function (o) {
                      return o.Type == 4 && o.IsRequired == true;
                  });

                  if (inputsFile.length > 0) {                        
                      _.each(inputsFile, function (o) {
                          
                          var extension = store.getFileExtension(o.Value).toLowerCase();                            

                          if (o.Value == null || o.AllowedExtensions.toLowerCase().indexOf(extension) == -1) {
                              self.errors.items.push({
                                  field: o.Name + o.Id,
                                  id: o.Id,
                                  msg: 'required',
                                  rule: 'required',
                                  scope: null,
                                  vmId: self.errors.vmId
                              });

                              isValid = false;
                          }
                          else {
                              var index = _.findIndex(self.errors.items, function (i) {
                                  return i.field == o.Name + o.Id;
                              })

                              if (index != -1) {
                                  self.errors.items.splice(index, 1);
                              }
                          }
                      });                        
                  }

                  if (isValid == true) {
                      $.when(
                          store.addToCart()
                      )
                      .then(function () {
                          // Update Cart
                          UpdateCart();
                      })
                  }
              })
              
          },
          onFileChanged: function (attribute, e) {
              var self = this;

              var index = _.findIndex(self.state.attributes, function (o) {
                  return o.Id == attribute.Id;
              })

              var files = e.target.files || e.dataTransfer.files;
              if (!files.length) {
                  // 
                  self.state.attributes[index].Value = null;
                  self.state.attributes[index].File = null;
                  return;
              }

              self.state.attributes[index].Value = files[0].name;
              self.state.attributes[index].File = files[0];                
          },
          toggleGroup: function (id, e) {
              e.preventDefault();
              store.toggleActiveGroup(id);                
          },
          isActiveGroup: function (id) {
              return this.state.status.activeGroup == id;
          }
      },
      computed: {
          
      },
      watch: {
          
      }
  }
</script>